<template>
    <section
        class="hero section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div
                    class="split-wrap"
                    :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]">
                    <div class="split-item">
                        <div class="hero-content split-item-content center-content-mobile">
                            <h1 class="mt-0 mb-16 reveal-from-left">
                                Licensed Customs Broker in Australia
                            </h1>
                            <p class="mt-0 mb-24 reveal-from-left" data-reveal-delay="200">
                                Line-1 Logistics is an ABF-licensed customs broker and DAFF-accredited freight partner. Customs clearance, international freight, warehousing and delivery — one team from wharf to door. 中英双语服务。
                            </p>
                            <div class="reveal-from-left" data-reveal-delay="400">
                                <c-tracking-search compact />
                            </div>
                        </div>
                        <div class="hero-figure is-3d split-item-image illustration-element-01 reveal-scale-up">
                            <c-image
                                class="has-shadow"
                                :src="require('@/assets/images/LAND6.jpg')"
                                alt="Hero image"
                                :width="528"
                                :height="396" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js'
import CImage from '@/components/elements/Image.vue'
import CTrackingSearch from '@/components/sections/TrackingSearch.vue'

export default {
  name: 'CHeroSplit',
  components: {
    CImage,
    CTrackingSearch
  },
  mixins: [SectionSplitProps]
}
</script>

<style scoped>
/* the hero image is decorative — hide it on narrow screens instead of
   toggling it with a window.onresize listener */
@media (max-width: 1000px) {
    .hero-figure {
        display: none;
    }
}
</style>
